import React from 'react';
import { reopenBanner } from '@/lib/consent';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200/70 py-12 bg-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center">
            <img
              src="/brand/mibax_logo_v2_transparent.png"
              alt="MIBAX Messtechnik – Logo: Wortmarke MIBAX mit kreisförmigem Schallwellen-Symbol"
              className="h-14 w-auto select-none"
              width="320"
              height="128"
              draggable="false"
              decoding="async"
              loading="lazy"
            />
          </div>
          <p className="text-slate-500 text-sm mt-4 max-w-sm">
            Ultraschall-Leckageortung & ISO 50001 Energieeffizienz-Analysen 
            für die Industrie. Präzise Ortung. Messbare Einsparung.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-400 mb-4">Leistungen</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><a href="#leistungen" className="hover:text-[#0891b2]">Leckageortung</a></li>
            <li><a href="#methode" className="hover:text-[#0891b2]">ISO 50001 Berichte</a></li>
            <li><a href="#angebot" className="hover:text-[#0891b2]">Monitoring-Abo</a></li>
            <li><a href="#roi" className="hover:text-[#0891b2]">ROI-Rechner</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-400 mb-4">Unternehmen</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li>MIBAX Messtechnik e.K.</li>
            <li>M.Basic@mibax-messtechnik.com</li>
            <li>+43 676 9218022</li>
            <li>Deutschland · Österreich · Schweiz</li>
            <li className="pt-2 text-slate-500 text-xs leading-relaxed">
              Amtsgericht München · HRA 123088
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 mt-10 pt-6 border-t border-slate-200/70 flex flex-col sm:flex-row justify-between gap-4 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-slate-400">
        <div>© {new Date().getFullYear()} MIBAX Messtechnik e.K. · Alle Rechte vorbehalten</div>
        <div className="flex gap-6 flex-wrap">
          <a href="/impressum" className="hover:text-[#0891b2]" data-testid="footer-impressum-link">Impressum</a>
          <a href="/datenschutz" className="hover:text-[#0891b2]" data-testid="footer-datenschutz-link">Datenschutz</a>
          <a href="/agb" className="hover:text-[#0891b2]" data-testid="footer-agb-link">AGB</a>
          <button
            type="button"
            onClick={reopenBanner}
            className="hover:text-[#0891b2] uppercase tracking-[0.2em] cursor-pointer"
            data-testid="footer-cookie-settings-link"
          >
            Cookie-Einstellungen
          </button>
        </div>
      </div>
    </footer>
  );
}
